// Arreglo para mantener las definiciones de las rutas de enlaces
const linksRoutes = [
  { path: 'calculadora', name: 'Calculadora', component: 'Calculadora' },
  { path: 'consultacobertura', name: 'ConsultaCobertura', component: 'ConsultaCobertura' },
  { path: 'vademecum', name: 'Vademecum', component: 'Vademecum' },
];

// Arreglo para mantener las definiciones de las rutas adicionales
const additionalRoutes = [
  { path: 'imc', name: 'IMC', component: 'IMC' },
];

// Combina los dos arreglos de rutas
const allRoutes = [
  ...linksRoutes.map(({ path, name, component }) => ({
    path: `/${path}`,
    name,
    // Importación dinámica para lograr la carga diferida de componentes de ruta
    component: () => import(`../views/enlaces/${component}.vue`)
  })),
  ...additionalRoutes.map(({ path, name, component }) => ({
    path: `/${path}`,
    name,
    // Importación dinámica para lograr la carga diferida de componentes de ruta
    component: () => import(`../views/utils/widgets/${component}.vue`)
  }))
];

export default allRoutes;
